const map = {
	"./bangladesh.jpg": 230,
	"./bhutan.jpg": 5985,
	"./brazil.jpg": 2959,
	"./cambodia.jpg": 831,
	"./china.jpg": 2496,
	"./egypt.jpg": 9280,
	"./greece.jpg": 1464,
	"./india.jpg": 2004,
	"./indonesia.jpg": 7187,
	"./ireland.jpg": 9240,
	"./japan.jpg": 2361,
	"./mexico.jpg": 532,
	"./nepal.jpg": 6371,
	"./nigeria.jpg": 7560,
	"./pakistan.jpg": 6352,
	"./sri-lanka.jpg": 8419,
	"./thailand.jpg": 6272,
	"./united-kingdom.jpg": 9692,
	"./united-states.jpg": 6137,
	"./vietnam.jpg": 2393
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1288;